// extracted by mini-css-extract-plugin
module.exports = {"container_modal":"reusableModal_container_modal__1NgC3","modal":"reusableModal_modal__2QSLQ","encabezado_modal":"reusableModal_encabezado_modal__3vSoV"};